export const login = {
    contentLogin: 'You can log in with AIS account',
    downloadApp: 'Download App AIS',
    downloadInstructions: 'Download instruction',
    buttonLogin: 'Log in',
    passwordLabel: 'Password',
    title: 'Log in',
    forGetPassword: 'Forgot password?',
    register: 'Register',
    noAccount: "You don't have an account?",
};
